import React, { Component } from "react";

import Menu from "./menu";

import "./css/swipe.css";

import swipeSlides1PNG from "./images/swipe/slides/1.png";
import swipeSlides2PNG from "./images/swipe/slides/2.png";
import swipeSlides3PNG from "./images/swipe/slides/3.png";
import swipeSlides4PNG from "./images/swipe/slides/4.png";
import swipeSlides5PNG from "./images/swipe/slides/5.png";
import swipeSlides6PNG from "./images/swipe/slides/6.png";
import swipeSlides7PNG from "./images/swipe/slides/7.png";

import swipeMarkdownEditorJPG from "./images/swipe/markdown_editor.jpg";
import swipeMarkdownEditorMP4 from "./images/swipe/markdown_editor.mp4";
import swipeDropFileUploadJPG from "./images/swipe/drop_file_upload.jpg";
import swipeDropFileUploadMP4 from "./images/swipe/drop_file_upload.mp4";
import swipeDragReorderJPG from "./images/swipe/drag_reorder.jpg";
import swipeDragReorderMP4 from "./images/swipe/drag_reorder.mp4";
import swipeDragReorderMobileJPG from "./images/swipe/drag_reorder_mobile.jpg";
import swipeDragReorderMobileMP4 from "./images/swipe/drag_reorder_mobile.mp4";
import swipeAddContentJPG from "./images/swipe/add_content.jpg";
import swipeAddContentMP4 from "./images/swipe/add_content.mp4";
import swipeDashboardManageDeckJPG from "./images/swipe/dashboard_manage_deck.jpg";
import swipeDashboardManageDeckMP4 from "./images/swipe/dashboard_manage_deck.mp4";
import swipeManageDeckJPG from "./images/swipe/manage_deck.jpg";
import swipeManageDeckMP4 from "./images/swipe/manage_deck.mp4";
import swipeDashboardAddCollaboratorJPG from "./images/swipe/dashboard_add_collaborator.jpg";
import swipeDashboardAddCollaboratorMP4 from "./images/swipe/dashboard_add_collaborator.mp4";

import swipeContentHeroPNG from "./images/swipe/content_hero.png";

class LogoSVG extends Component {
  render() {
    return (
      <svg width="160px" viewBox="0 0 55 23">
        <g>
          <path d="M30.681688,0 C30.0638407,0 29.5625,0.502711293 29.5625,1.11971628 C29.5625,1.73672126 30.0638407,2.23958333 30.681688,2.23958333 C31.2987807,2.23958333 31.8020833,1.73672126 31.8020833,1.11971628 C31.8020833,0.502711293 31.2987807,0 30.681688,0"></path>
          <path d="M25.5165426,5.85681306 C25.5005062,5.83599099 25.4798192,5.82291667 25.4530384,5.82291667 L23.3035184,5.82291667 C23.268078,5.82291667 23.2366466,5.85035661 23.2278266,5.88409159 L21.2797239,14.0201952 L18.8811585,5.88005631 C18.8710556,5.84632132 18.8396242,5.82291667 18.8061081,5.82291667 L17.0273499,5.82291667 C16.9925509,5.82291667 16.9624024,5.84648273 16.9524598,5.88005631 L14.5627145,14.0201952 L12.6152532,5.88409159 C12.6064332,5.85035661 12.5770866,5.82291667 12.5395614,5.82291667 L10.3786556,5.82291667 C10.3539595,5.82291667 10.3310274,5.83599099 10.3170758,5.85681306 C10.3023223,5.87747372 10.2983132,5.90087838 10.3056899,5.92444444 L13.6143214,16.9675676 C13.6223396,16.99872 13.6537709,17.0208333 13.687287,17.0208333 L15.547831,17.0208333 C15.5845543,17.0208333 15.6132595,16.99872 15.622721,16.9675676 L17.9160875,9.10441066 L20.2201985,16.9675676 C20.2303014,16.99872 20.2585255,17.0208333 20.2958903,17.0208333 L22.1564342,17.0208333 C22.18979,17.0208333 22.2213817,16.99872 22.2300413,16.9675676 L25.5279284,5.92444444 C25.5346637,5.90103979 25.5312961,5.87747372 25.5165426,5.85681306"></path>
          <path d="M29.4787322,5.82291667 L27.4039598,5.82291667 C27.3585007,5.82291667 27.3229167,5.85939565 27.3229167,5.90362237 L27.3229167,16.9441629 C27.3229167,16.9882282 27.3583305,17.0208333 27.4039598,17.0208333 L29.4787322,17.0208333 C29.5248723,17.0208333 29.5624994,16.9883896 29.5624994,16.9441629 L29.5624994,5.90362237 C29.5626697,5.85939565 29.5248723,5.82291667 29.4787322,5.82291667"></path>
          <path d="M36.8709542,7.61458333 C37.6668243,7.61458333 38.2937158,7.96925964 38.7385456,8.6629405 C39.187789,9.36453972 39.4166667,10.4155363 39.4166667,11.7801328 C39.4166667,13.2257274 39.1753363,14.3258838 38.6969315,15.0499184 C38.2273539,15.7648798 37.5859605,16.125 36.7893022,16.125 C35.7606137,16.125 34.8362757,15.6786028 34.0416667,14.7988406 L34.0416667,9.49750209 C34.8928646,8.25085613 35.8439996,7.61458333 36.8709542,7.61458333 M40.447795,7.38918998 C39.6428606,6.35032865 38.4885325,5.82291667 37.0215975,5.82291667 C35.8340478,5.82291667 34.7980209,6.3072779 33.9350703,7.26068268 L33.9350703,6.15023135 C33.9350703,6.10863175 33.8986076,6.07235303 33.8558247,6.07235303 L31.8798704,6.07235303 C31.8378978,6.07235303 31.8020833,6.10879299 31.8020833,6.15023135 L31.8020833,21.4232504 C31.8020833,21.4661399 31.8378978,21.5 31.8798704,21.5 L33.8558247,21.5 C33.8986076,21.5 33.9350703,21.4661399 33.9350703,21.4232504 L33.9350703,16.501276 C34.7432459,17.175254 35.7360037,17.5206274 36.8877389,17.5206274 C38.2551712,17.5206274 39.4069064,16.9801551 40.3050233,15.9154956 C41.2024919,14.858253 41.65625,13.3972686 41.65625,11.5778505 C41.656412,9.83082851 41.2499744,8.41902193 40.447795,7.38918998"></path>
          <path d="M48.1419873,7.61458333 C48.8956881,7.61458333 49.5413606,7.88473322 50.0632375,8.41597207 C50.5693474,8.93361953 50.9049846,9.71604744 51.0625,10.75 L45.2395833,10.75 C45.3906982,9.70782549 45.7275843,8.92254506 46.2408752,8.40909248 C46.7680599,7.88087394 47.4071758,7.61458333 48.1419873,7.61458333 M51.8980664,7.34853384 C50.9657991,6.33883981 49.7035285,5.82291667 48.1455838,5.82291667 C46.6197535,5.82291667 45.3693479,6.34526076 44.4214189,7.37453867 C43.4799761,8.40510078 43,9.83905892 43,11.6452715 C43,13.4668944 43.4937394,14.9072734 44.4695114,15.9286857 C45.44734,16.950098 46.7531154,17.46875 48.358678,17.46875 C49.6084508,17.46875 50.6813571,17.1520368 51.5508193,16.5325758 C52.4255021,15.907015 52.9445534,15.0082428 53.0975319,13.8613011 C53.1008541,13.8380251 53.0923113,13.8186018 53.0771242,13.7967705 C53.0646265,13.7800761 53.042795,13.7709262 53.0196979,13.7709262 L51.0311353,13.7709262 C50.9922183,13.7709262 50.9578891,13.8046362 50.9558325,13.8473355 C50.9286223,14.4664754 50.6618986,14.9308704 50.137785,15.2694149 C49.6122476,15.6095646 49.0147296,15.7802013 48.3585198,15.7802013 C47.4944363,15.7802013 46.7543809,15.4801825 46.1647729,14.8815897 C45.586397,14.2959992 45.24706,13.3933745 45.1586267,12.1896073 L53.2236166,12.1896073 C53.2664885,12.1896073 53.3020833,12.1531685 53.3020833,12.1131981 L53.3020833,11.6452715 C53.3020833,9.80518842 52.8308082,8.35726472 51.8980664,7.34853384"></path>
          <path d="M8.38947002,11.6326702 C7.73001189,11.2014976 6.71144129,10.8202486 5.36208349,10.4988757 C4.02835344,10.181195 3.18592051,9.92611932 2.85822631,9.74087242 C2.54599706,9.56445445 2.39411495,9.28353412 2.39411495,8.88221936 C2.39411495,8.43178367 2.59581048,8.09821084 3.01059679,7.86271934 C3.43384811,7.62225153 3.97674934,7.50041237 4.62448666,7.50041237 C6.09333156,7.50041237 6.84020737,7.98439797 6.90743921,8.98046121 C6.91020662,9.02123479 6.94471789,9.05317945 6.98622907,9.05317945 L8.95971979,9.05317945 C8.98104515,9.05317945 9.00155656,9.04451105 9.01653314,9.02942161 C9.03134694,9.01417165 9.0393236,8.99378486 9.03867244,8.97275597 C8.9743708,6.88270869 7.44317772,5.82291667 4.48790671,5.82291667 C3.2155481,5.82291667 2.1836288,6.13000272 1.42031131,6.73550643 C0.65211015,7.34518382 0.262556138,8.12662392 0.262556138,9.05815575 C0.262556138,10.0885715 0.579831846,10.8208907 1.20559266,11.234566 C1.81556294,11.6382886 2.79148283,12.0071771 4.10632936,12.3322421 C5.40619931,12.653615 6.27516684,12.9178406 6.68881362,13.1181769 C7.08292572,13.3095238 7.27452835,13.6302546 7.27452835,14.0991507 C7.27452835,14.5821732 7.07315839,14.9735353 6.65902324,15.2957108 C6.24521367,15.6177258 5.63117367,15.7808201 4.83415886,15.7808201 C3.03615465,15.7808201 2.1556291,15.1491507 2.14195483,13.8500145 C2.14146646,13.8069936 2.10614125,13.7728016 2.06300218,13.7728016 L0.0789301771,13.7728016 C0.0571164548,13.7728016 0.0364422553,13.7816305 0.0214656698,13.797362 C0.00665187329,13.812933 -0.00116199739,13.8339619 0.000140314389,13.8551514 C0.142417876,16.2530873 1.77584243,17.46875 4.85532142,17.46875 C6.23235334,17.46875 7.3459927,17.1302009 8.16498403,16.4624131 C8.98853344,15.7907727 9.40624994,14.9330828 9.40624994,13.9126196 C9.40641273,12.8412697 9.06423031,12.0741164 8.38947002,11.6326702 Z"></path>
        </g>
      </svg>
    );
  }
}

class Swipe extends Component {
  render() {
    return (
      <div className="swipe-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="section">
            <LogoSVG />
            <p>What is a presentation?</p>
          </div>
          <div id="swipe-examples">
            <img src={swipeSlides1PNG} alt="" className="slide-1" />
            <img src={swipeSlides2PNG} alt="" className="slide-2" />
            <img src={swipeSlides3PNG} alt="" className="slide-3" />
            <img src={swipeSlides4PNG} alt="" className="slide-4" />
            <img src={swipeSlides5PNG} alt="" className="slide-5" />
            <img src={swipeSlides6PNG} alt="" className="slide-6" />
            <img src={swipeSlides7PNG} alt="" className="slide-7" />
          </div>
        </div>

        <div className="section-wrapper">
          <div className="section context">
            <div className="column">
              <h1>Presentations go beyond the projector</h1>
              <h2>Opportunity</h2>
              <p>
                The rigid constraints of print and television mediums no longer make sense in a world where everyone is
                walking around with connected computers in their pockets. Authoring tools haven't advanced past allowing
                us to build and share digital versions of document models of the past.
              </p>
              <p>
                We already have a viable alternative to the old overhead projector metaphor. Today's devices are built
                around one main technology: the web browser. The browser has evolved around as much as it has shaped the
                devices of today. A presentation is a website.
              </p>
              <h2>Introduction</h2>
              <p>
                Swipe initially allowed users to swiftly convert PowerPoint-style presentations into accessible online
                formats, using their phone as a remote for live presentations. It added a new layer to existing tools,
                but once presentations were online, the potential for significant improvements became clear.
              </p>
              <p>
                I joined the project early on and took on roles as Product Design Lead and Senior Front-End Developer in
                2014. I dedicated myself to enhancing the product, driven by a belief in the web's potential to deliver
                robust tools that compete with native applications.
              </p>
              <p>Below, I'll highlight some of the final design solutions and features that I contributed to.</p>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Content first</h2>
              <p>
                The guiding principle we followed was to get out of the way and put the content first. There is never
                more UI than you need and we dedicate as much screen real estate to your content as possible.
              </p>
            </div>
            <div className="image-wrapper">
              <img src={swipeContentHeroPNG} alt="Screenshot of Swipe application" />
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Simple by design</h2>
              <p>
                Markdown was the obvious choice for markup language when Swipe began experimenting with slide authoring.
                It was important to build an editor that provides a really good experience to both expert and novice
                markdown authors.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeMarkdownEditorJPG}>
                <source src={swipeMarkdownEditorMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Make the invisible visible</h2>
              <p>
                Uploading dozens of files at once is a common scenario. Our upload manager offers complete control,
                allowing you to pause, cancel, and retry failed uploads. Importantly, this makes uploading files less
                disruptive—you can continue editing your presentation or switch to another without waiting for uploads
                to finish.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeDropFileUploadJPG}>
                <source src={swipeDropFileUploadMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>The path to success is not linear</h2>
              <p>
                It was very important that the tool makes it as simple as possible to massage and mould a presentation.
                This means predictable multi-select and drag and drop support that you can trust. Because you're likely
                to make last minute changes these tools should work equally well on mobile.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeDragReorderJPG}>
                <source src={swipeDragReorderMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
            <div className="column">
              <p>
                On mobile even a small collection feels large. The drag auto-scroll interaction done right feels so
                natural it becomes invisible. We also found that the scrolling behavior needed to be tuned differently
                based on screen size for it to feel right.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeDragReorderMobileJPG}>
                <source src={swipeDragReorderMobileMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Be smart</h2>
              <p>
                Embedding 3rd party content was a tiresome multi-step process. The solution was to add a smart text
                field above the content menu. Pasting a supported content URL brings you straight to the confirmation
                step. This power move makes you lightning fast. To make it even better all menu navigation is usable
                from the keyboard, no mouse required.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeAddContentJPG}>
                <source src={swipeAddContentMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Be consistent</h2>
              <p>
                You won't find any modal dialogs in Swipe because we worked hard to make all interaction contextual and
                in place.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeDashboardManageDeckJPG}>
                <source src={swipeDashboardManageDeckMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
            <div className="column">
              <p>
                In the same spirit, you'll see controls like the deck management equally at home in different contexts
                throughout the product.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeManageDeckJPG}>
                <source src={swipeManageDeckMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Enable synergy</h2>
              <p>
                Private by design with granular permission controls that you expect from a modern tool. Emailing Keynote
                files back and forth is a thing of the past.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={swipeDashboardAddCollaboratorJPG}>
                <source src={swipeDashboardAddCollaboratorMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider conclusion">
          <div className="section">
            <div className="column">
              <h2>Looking ahead</h2>
              <p>
                I've only scratched the surface of what Swipe is and haven't touched on what we want it to become. I'm
                grateful for the indulgent opportunity to design the tools I want to use and the space to build what I
                dreamt up. Swipe serves many tens of thousands of customers and together we've created countless
                interactive lessons, pitch decks, conference keynotes, photo albums, mood boards, prototypes, portfolio
                websites, documents and more. Because what is a presentation anyway?
              </p>
              <p>
                Update: Swipe was acquired by Whereby in 2019. Unfortunately the service will wind down but I'm excited
                to continue working on these ideas in a new context.
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Swipe;



// WEBPACK FOOTER //
// ./src/swipe.js